module.exports = __webpack_public_path__ + "img/placeholder_4_16to9.e1fc25d2.svg";